import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { CowingSecurityEncryptService } from "../../services/cowingSecurityEncrypt.service";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";

@Component({
  selector: "cowing-core-coworking-bank-info",
  templateUrl: "./coworking-bank-info.component.html",
  styleUrls: ["./coworking-bank-info.component.scss"],
})
export class CoworkingBankInfoComponent implements OnInit {
  @Input("form") form: FormGroup;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;

  constructor(
    private coworkingService: CoworkingService,
    private router: Router,
    private _store: Store<IAppState>,
    private translate: TranslateService,
    private cowingSecurityEncryptService: CowingSecurityEncryptService
  ) {}

  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));

    try {
      const coworkingId = LocalStorageService.instance.get(
        EStorageType.ActiveCoworking
      );
      if (coworkingId && this.isEditingInfo) {
        const response = await this.coworkingService.getCoworkingPaymethods(
          coworkingId
        );
        const responseDecrypted =
          this.cowingSecurityEncryptService.decrypt(response);
        this.form.patchValue(JSON.parse(responseDecrypted));
      }
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this.isEditingInfo && this.form.disable();
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  public get isDisabledForm() {
    // console.log(this.form);
    return this.form.dirty && this.form.valid ? false : true;
  }
  public goBack() {
    this.router.navigate(["coworking-home"]);
  }
  public setLocation(event) {}
  public get isEditingInfo() {
    return this.router.url === "/coworking-bank-info" ? true : false;
  }
}
